// Legacy alias — canonical route is /automations/enrollment/[enrollmentID].
// Old enrollment links map to the run detail screen (same screen, new copy).
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function EnrollmentAlias() {
    const params = useLocalSearchParams();
    return <Redirect href={{ pathname: '/automations/enrollment/[enrollmentID]', params }} />;
}
